import { Redirect } from "expo-router";
import { StartupStateScreen } from "../src/components/StartupStateScreen";
import { useStartup } from "../src/hooks/useStartup";
import { useNotificationRouting } from "../src/components/notificationRoutingContext";

export default function Index() {
  const { status, retry } = useStartup();
  const { responseReady, hasPendingNotificationIntent } = useNotificationRouting();

  if (status === "loading") return <StartupStateScreen mode="loading" />;
  if (status === "offline") return <Redirect href="/(tabs)" />;
  if (status === "recoverable_error") {
    return <StartupStateScreen mode="error" offline={false} onRetry={retry} />;
  }

  if (status === "signed_out") return <Redirect href="/(auth)/login" />;
  if (status === "onboarding_required") return <Redirect href="/(auth)/onboarding" />;
  if (status === "ready" && (!responseReady || hasPendingNotificationIntent)) {
    return <StartupStateScreen mode="loading" />;
  }
  return <Redirect href="/(tabs)" />;
}
